<template>
<div class="mt-2" v-if="bookContent.contentHtml!=null" >
                    <div class="mb-2">
                        <img src="../../../assets/images/book/book-title-logo.png" alt="" class="book-title-logo">
                        <div class="book-titles">
                            <span class="book-title">{{BookParentTitle}}</span> <span class="book-title-2">{{BookSubTitle}}</span>
                            <span class="book-sub-title">Speaking Practice</span>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                    <SubjectBookImage v-if="bookContent.sectionImageUrl" :url="bookContent.sectionImageUrl" banner alt="Diyalog bölümü görseli" />
                    <div class="book-contents">
                        <div class="book-bg">
                            <img src="../../../assets/images/book/book-bg-logo.png" class="lengedu-logo">
                        </div>
                        <div class="book-content">
                            <ContentLanguageSwitch v-if="hasTranslation && bookContent.contentDialogs.length === 0" :language="language" @language="$emit('change-language', $event)" />
                            <div v-if="bookContent.contentDialogs.length === 0 && bookContent.contentTitle!=null" class="title">{{ bookContent.contentTitle }}</div>
                            <div v-if="bookContent.contentDialogs.length==0" v-html="bookContent.contentHtml"></div>
                            <SubjectDialogContent ref="dialogs" v-if="bookContent.contentDialogs.length > 0" :dialogs="bookContent.contentDialogs" :is-ready-audio-button="isReadyAudioButton" :active-dialog="activeDialog" @play-audio="(audio, event) => $emit('play-audio', audio, event)">
                                <template #language><ContentLanguageSwitch v-if="hasTranslation" :language="language" @language="$emit('change-language', $event)" /></template>
                                <template #title>
                                    <div v-if="bookContent.contentTitle!=null" class="title">{{ bookContent.contentTitle }}</div>
                                </template>
                            </SubjectDialogContent>
                                </div>
  </div>
</div>
</template>
<script>
import ContentLanguageSwitch from './ContentLanguageSwitch.vue';
import SubjectDialogContent from './SubjectDialogContent.vue';
import SubjectBookImage from './SubjectBookImage.vue';
export default {
  name: 'SubjectHtmlContent',
  methods: { stop() { this.$refs.dialogs?.stop(); } },
  components: { SubjectDialogContent, SubjectBookImage, ContentLanguageSwitch },
  emits: ['change-language', 'play-audio'],
  props: {
    bookContent: { type: Object, required: true },
    BookParentTitle: String, BookSubTitle: String,
    externalLanguageControl: Boolean, hasTranslation: Boolean, language: String,
    ChangeLanguageButtonText: String, isReadyAudioButton: Boolean, activeDialog: { type: Number, default: null }
  }
};
</script>
